import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10f4f6b5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "vertical-scroll-content" };
import { ElScrollbar } from "element-plus";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'VerticalScroll',
    props: {
        offset: { default: 30 },
        maxHeight: { default: "" }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "c7e51370": (marginRight.value),
            "06775291": (paddingRight.value)
        }));
        const props = __props;
        const marginRight = computed(() => {
            return -props.offset + "px";
        });
        const paddingRight = computed(() => {
            return props.offset + "px";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElScrollbar), {
                minSize: 100,
                maxHeight: _ctx.maxHeight,
                class: "vertical-scroll"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["maxHeight"]));
        };
    }
});
